import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import SelectAsync from 'react-select/async';

export default class TimeSheetsReport extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'timesheet',
            data: null,
            loading: true,
            time_sheet_header_id: this.getDefaultGuid(),
            man_company_id: this.getDefaultGuid(),
            man_company_name: '',
            timeSheets: [],
            timeSheetTotal: 0,
            timeSheetMamoriyatTotal: 0,
            timeSheetExtraTotal: 0,
            timeSheetReduceTotal: 0,
            timeSheetHeader: null,
            manCompanyInTimeSheet: false,
            menuId: 66
        };
    }
    componentDidMount() {
        this.refreshData(null, "report");
    }
    setTimeSheet(e) {
        this.state.time_sheet_header_id = e.target.value;
        this.state.manCompanyInTimeSheet = false;

        this.state.data.timeSheetHeaders.forEach(t => {
            if (t.id === this.state.time_sheet_header_id) {
                if (t.manCompanyId != this.getDefaultGuid()) {
                    this.state.man_company_id = t.manCompanyId;
                    this.state.man_company_name = '';
                    this.state.manCompanyInTimeSheet = true;
                }
            }
        })
        
        this.getTimeSheets();
    }
    setManCompany(e) {
        this.state.man_company_id = e.value;
        this.state.man_company_name = e.label;
        this.getTimeSheets();
    }
    getTimeSheets() {
        var time_sheet_header_id = this.state.time_sheet_header_id;
        var man_company_id = this.state.man_company_id;

        if (time_sheet_header_id == this.getDefaultGuid() || man_company_id == this.getDefaultGuid()) {
            this.setState({
                timeSheets: [],
            })
            return;
        }

        this.setState({ loading: true });

        this.httpPost("api/v1/" + this.state.controllerName + "/list", {
            time_sheet_header_id,
            man_company_id
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 0) {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
                else {
                    this.setState({
                        time_sheet_header_id,
                        timeSheets: data.records,
                        timeSheetTotal: data.timeSheetTotal,
                        timeSheetMamoriyatTotal: data.timeSheetMamoriyatTotal,
                        timeSheetExtraTotal: data.timeSheetExtraTotal,
                        timeSheetReduceTotal: data.timeSheetReduceTotal,
                        timeSheetHeader: data.timeSheetHeader,
                        loading: false
                    })
                }
            })
    }
    getHours() {
        var s = [];
        for (var i = 0; i <= 24; i++) s.push(i);
        return s;
    }
    getMinutes() {
        var s = [];
        for (var i = 0; i <= 60; i++) s.push(i);
        return s;
    }
    getMonthName(e) {
        if (e == 1) return "فروردین";
        if (e == 2) return "اردیبهشت";
        if (e == 3) return "خرداد";
        if (e == 4) return "تیر";
        if (e == 5) return "مرداد";
        if (e == 6) return "شهریور";
        if (e == 7) return "مهر";
        if (e == 8) return "آبان";
        if (e == 9) return "آذر";
        if (e == 10) return "دی";
        if (e == 11) return "بهمن";
        if (e == 12) return "اسفند";
        return "";
    }
    getDays() {
        var s = [];
        for (var i = 1; i <= 31; i++) s.push(i);
        return s;
    }
    getLineSeries() {
        var r = [];
        var r2 = [];
        var r3 = [];
        this.state.timeSheets.forEach(header => {
            var sum = 0;
            var sum2 = 0;
            var sum3 = 0;
            this.state.timeSheets.forEach(data => {
                if (data.dayNameString === header.dayNameString && data.day === header.day) {
                    sum += data.duration;
                    if (data.type == 1) sum2 += data.duration;
                    if (data.type == 2) sum3 += data.duration;
                }
            });
            r.push([header.dayNameString + " " + header.day + " " + this.getMonthName(this.state.timeSheetHeader.month), sum]);
            r2.push([header.dayNameString + " " + header.day + " " + this.getMonthName(this.state.timeSheetHeader.month), sum2]);
            r3.push([header.dayNameString + " " + header.day + " " + this.getMonthName(this.state.timeSheetHeader.month), sum3]);
        });
        return [
            {
                data: r,
                name: 'کارکرد کل',
                type: 'line'
            },
            {
                data: r2,
                name: 'کارکرد خود اظهاری',
                type: 'line'
            },
            {
                data: r3,
                name: 'کارکرد بر مبنای انجام وظایف',
                type: 'line'
            }
        ];
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        return <div>
            <div className="nk-content-body">
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="col-lg-12">
                            <div className="card h-100">
                                <div className="card-inner">
                                    <div className="row g-4">
                                        <div className="col-lg-8">
                                            <div className="form-group">
                                                <label className="form-label">تایم شیت کاری</label>
                                                <div className="form-control-wrap">
                                                    <select defaultValue={this.state.time_sheet_header_id} className="form-control" onChange={e => this.setTimeSheet(e)}>
                                                        <option value={this.getDefaultGuid()}>لطفا یکی از تایم شیتها را انتخاب نمایید</option>
                                                        {this.state.data.timeSheetHeaders.map(record =>[
                                                            record.type === 1 && <option value={ record.id } >
                                                            قرارداد شماره {record.contractNumber} شرکت {record.companyName} با موضوع {record.contractSubject} - {this.getMonthName(record.month)} {record.year}
                                                            </option>
                                                            ,
                                                            record.type === 2 && <option value={record.id} >
                                                                {record.solutionTitle} - {this.getMonthName(record.month)} {record.year}
                                                            </option>
                                                            ,
                                                            record.type === 3 && <option value={record.id} >
                                                                {record.crmTeamTitle} - {this.getMonthName(record.month)} {record.year}
                                                            </option>
                                                        ])}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        {!this.state.manCompanyInTimeSheet && <div className="col-lg-4">
                                            <div className="form-group">
                                                <label className="form-label">کارمند</label>
                                                <div className="form-control-wrap">
                                                    <SelectAsync
                                                        defaultValue={this.state.man_company_id != this.getDefaultGuid() ? [{ value: this.state.man_company_id, label: this.state.man_company_name }] : null}
                                                        isMulti={false}
                                                        placeholder="انتخاب کارمند"
                                                        defaultOptions
                                                        loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 0, 3)}
                                                        onChange={e => this.setManCompany(e)}
                                                    />
                                                </div>
                                            </div>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {!this.isEmpty(this.state.timeSheets) && <div className="card-inner-group">
                            {this.state.timeSheetHeader.type === 1 && <div className="card-inner p-0">
                                <div className="nk-tb-list nk-tb-ulist">
                                    <div className="nk-tb-item nk-tb-head">
                                        <div className="nk-tb-col"><span className="sub-text">ردیف</span></div>
                                        <div className="nk-tb-col tb-col-sm"><span className="sub-text text-center">روز ماه</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">عنوان روز</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">موظفی</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">ورود</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">خروج</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">کارکرد</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">زمان کارکرد</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">جمعه کاری</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">تعطیل کاری</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">ماموریت</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">اضافه کاری</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">کم کاری</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">توضیحات کارکرد</span></div>
                                        <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                    </div>
                                    {this.state.timeSheets.map((record, index) =>
                                        <div className="nk-tb-item">
                                            <div className="nk-tb-col">
                                                <span className="sub-text">{(index + 1)}</span>
                                            </div>
                                            <div className="nk-tb-col tb-col-md">
                                                <span className="sub-text text-center">{record.day}</span>
                                            </div>
                                            <div className="nk-tb-col tb-col-md">
                                                <span className="sub-text text-center">{record.dayName}</span>
                                            </div>
                                            <div className="nk-tb-col tb-col-md">
                                                <span className="sub-text text-center">{this.FixedPointNumber((record.moazzafTime / 60), 2)}</span>
                                            </div>
                                            <div className="nk-tb-col tb-col-md">
                                                <span className="sub-text text-center">{record.enterHour}:{record.enterMinute}</span>
                                            </div>
                                            <div className="nk-tb-col tb-col-md">
                                                <span className="sub-text text-center">{record.exitHour}:{record.exitMinute}</span>
                                            </div>
                                            <div className="nk-tb-col tb-col-md text-center">
                                                {this.displayMinuteAsTimeFormat(record.duration)}
                                            </div>
                                            <div className="nk-tb-col tb-col-md text-center">
                                                {record.timeMode === 1 && <span class="tb-status text-info">روزکار</span>}
                                                {record.timeMode === 2 && <span class="tb-status text-warning">شبکار</span>}
                                                {record.timeMode === 3 && <span class="tb-status text-success">نوبتکاری</span>}
                                            </div>
                                            <div className="nk-tb-col tb-col-md text-center">
                                                {record.fridayTime == 0 && <span class="tb-status text-danger">خیر</span>}
                                                {record.fridayTime != 0 && <span class="tb-status text-success">بله</span>}
                                            </div>
                                            <div className="nk-tb-col tb-col-md text-center">
                                                {record.holidayTime == 0 && <span class="tb-status text-danger">خیر</span>}
                                                {record.holidayTime != 0 && <span class="tb-status text-success">بله</span>}
                                            </div>
                                            <div className="nk-tb-col tb-col-md text-center">
                                                {this.displayMinuteAsTimeFormat(record.mamoriyatTime)}
                                            </div>
                                            <div className="nk-tb-col tb-col-md text-center">
                                                {this.displayMinuteAsTimeFormat(record.extraTime)}
                                            </div>
                                            <div className="nk-tb-col tb-col-md text-center">
                                                {this.displayMinuteAsTimeFormat(record.reduceTime)}
                                            </div>
                                            <div className="nk-tb-col tb-col-md">
                                                <span className="sub-text text-center">{record.description}</span>
                                            </div>
                                            <div className="nk-tb-col nk-tb-col-tools">
                                                <ul className="nk-tb-actions gx-1">
                                                    <li className="nk-tb-action-hidden">
                                                        <a className="btn btn-trigger btn-icon hand" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف رکورد">
                                                            <em className="icon ni ni-cross-fill-c"></em>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                                    <div className="nk-tb-item">
                                        <div className="nk-tb-col">
                                            <span className="sub-text">جمع کل</span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md text-center">
                                            {this.displayMinuteAsTimeFormat(this.state.timeSheetTotal)}
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md text-center">
                                            {this.displayMinuteAsTimeFormat(this.state.timeSheetMamoriyatTotal)}
                                        </div>
                                        <div className="nk-tb-col tb-col-md text-center">
                                            {this.displayMinuteAsTimeFormat(this.state.timeSheetExtraTotal)}
                                        </div>
                                        <div className="nk-tb-col tb-col-md text-center">
                                            {this.displayMinuteAsTimeFormat(this.state.timeSheetReduceTotal)}
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            {this.state.timeSheetHeader.type === 2 && <div className="card-inner p-0">
                                <h4 className="mt-4 text-center">گزارش کارکرد {this.getMonthName(this.state.timeSheetHeader.month)} ماه</h4>
                                <div className="nk-tb-list nk-tb-ulist">
                                    <div className="nk-tb-item nk-tb-head">
                                        <div className="nk-tb-col"><span className="sub-text">ردیف</span></div>
                                        <div className="nk-tb-col tb-col-sm"><span className="sub-text text-center">روز</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">عنوان روز</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">زمان کارکرد</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">شرح وظیفه</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">شرح اقدامات انجام یافته</span></div>
                                    </div>
                                    {this.state.timeSheets.map((record, index) =>
                                        <div className="nk-tb-item">
                                            <div className="nk-tb-col">
                                                <span className="sub-text">{(index + 1)}</span>
                                            </div>
                                            <div className="nk-tb-col tb-col-md">
                                                <span className="sub-text text-center">{record.day}</span>
                                            </div>
                                            <div className="nk-tb-col tb-col-md">
                                                <span className="sub-text text-center">{record.dayNameString}</span>
                                            </div>
                                            <div className="nk-tb-col tb-col-md text-center">
                                                {this.displayMinuteAsTimeFormat(record.duration)}
                                            </div>
                                            <div className="nk-tb-col tb-col-md">
                                                <span className="sub-text text-center">{record.description}</span>
                                            </div>
                                            <div className="nk-tb-col tb-col-md">
                                                <span className="sub-text text-center">{record.note}</span>
                                            </div>
                                        </div>
                                    )}
                                    <div className="nk-tb-item">
                                        <div className="nk-tb-col">
                                            <span className="sub-text">جمع کل</span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md text-center">
                                            {this.displayMinuteAsTimeFormat(this.state.timeSheetTotal)}
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-4">
                                    <HighchartsReact
                                        highcharts={Highcharts}
                                        options={{
                                            title: {
                                                text: 'روند کارکرد به تفکیک روزهای ماه'
                                            },
                                            series: this.getLineSeries(),
                                            xAxis: {
                                                title: {
                                                    text: 'روزهای ماه'
                                                },
                                                type: 'category',
                                            },
                                            yAxis: {
                                                title: {
                                                    text: 'کارکرد به دقیقه'
                                                },
                                            },
                                        }
                                        }
                                     />
                                </div>
                            </div>}
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}